import {ChartDataSets, ChartOptions, ChartType} from 'chart.js';

/* ------------ TABLE CONFIGURATION ------------ */

export interface QuestionnaireIBDDisk {
  position: number;
  question: string;
  description: string;
}

export const Q_IBD_DISK: QuestionnaireIBDDisk[] = [
  {
    position: 1, question: 'Dolori addominali',
    description: 'Ho avuto dolori allo stomaco o addominali'
  },
  {
    position: 2, question: 'Controllo evacuazioni',
    // tslint:disable-next-line:max-line-length
    description: 'Ho avuto difficoltà nel coordinare e controllare le evacuazioni, incluso la scelta di un posto appropriato per la defecazione e la successiva pulizia personale'
  },
  {
    position: 3, question: 'Interazioni interpersonali',
    description: 'Ho avuto difficoltà con le relazioni personali e/o difficoltà a partecipare nella comunità'
  },
  {
    position: 4, question: 'Educazione e lavoro',
    // tslint:disable-next-line:max-line-length
    description: 'Ho avuto difficoltà con le attività scolastiche o di studio, e/o difficoltà con il lavoro o con le faccende domestiche'
  },
  {
    position: 5, question: 'Sonno',
    // tslint:disable-next-line:max-line-length
    description: 'Ho avuto difficoltà nel dormire, ad esempio con l\'addormentarmi, svegliandomi frequentemente la notte o svegliandomi troppo presto la mattina'
  },
  {
    position: 6, question: 'Energia',
    description: 'Non mi sono sentito riposato durante la giornata, e mi sono sentito stanco e senza energie'
  },
  {
    position: 7, question: 'Emozioni',
    description: 'Mi sono sentito triste, giù di morale o depresso, e/o preoccupato o ansioso'
  },
  {
    position: 8, question: 'Visione del proprio corpo',
    description: 'Non mi è piaciuto il modo in cui appare il mio corpo o parti del mio corpo'
  },
  {
    position: 9, question: 'Funzioni sessuali',
    description: 'Ho avuto difficoltà con aspetti sessuali mentali e/o fisici'
  },
  {
    position: 10, question: 'Dolori articolari',
    description: 'Ho avuto dolore alle articolazioni del mio corpo'
  }
];

/* ------------ RADAR CHART CONFIGURATION ------------ */

export const radarChartLabels: string[] = [
    'Dolori addominali',
    'Controllo evacuazioni',
    'Interazioni interpersonali',
    'Educazione e lavoro',
    'Sonno',
    'Energia',
    'Emozioni',
    'Visione corpo',
    'Funzioni sessuali',
    'Dolori articolari'
];

export const radarChartData: ChartDataSets[] = [
  { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'Questionario' },
];

export const radarChartType: ChartType = 'radar';

export const radarChartOptions: ChartOptions = {
  maintainAspectRatio: false,
  legend: {
    display: false,
    position: 'left',
    labels: {
      fontFamily: 'Exo, sans-serif',
      fontSize: 12,
      fontColor: 'black'
    }
  },
  scale: {
    pointLabels: {
      fontFamily: 'Exo, sans-serif',
      fontSize: 15,
      fontColor: 'black'
    },
    ticks: {
      beginAtZero: true,
      max: 10,
      min: 0,
      stepSize: 1
    }
  },
  title: {
    display: false,
    position: 'top',
    fontFamily: 'Exo, sans-serif',
    fontSize: 25,
    fontColor: 'black',
    text: 'Sintesi',
    padding: 50
  },
  responsive: true,
};

/* ------------ RESULTS CONFIGURATION + CONSTRUCTOR ------------ */

export class IBDDiskResults {
  patientSSN: string;
  doctorID: string;
  results: number[];

  constructor(doctorID: string, patientSSN: string, results: number[]) {
    this.doctorID = doctorID;
    this.patientSSN = patientSSN;
    this.results = results;
  }

}
